"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingRefError = exports.ValidationError = void 0;

var resolve_1 = require("./resolve");

var ValidationError = /*#__PURE__*/function (_Error) {
  _inherits(ValidationError, _Error);

  function ValidationError(errors) {
    var _this;

    _classCallCheck(this, ValidationError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ValidationError).call(this, "validation failed"));
    _this.errors = errors;
    _this.ajv = _this.validation = true;
    return _this;
  }

  return ValidationError;
}(_wrapNativeSuper(Error));

exports.ValidationError = ValidationError;

var MissingRefError = /*#__PURE__*/function (_Error2) {
  _inherits(MissingRefError, _Error2);

  function MissingRefError(baseId, ref, msg) {
    var _this2;

    _classCallCheck(this, MissingRefError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(MissingRefError).call(this, msg || "can't resolve reference ".concat(ref, " from id ").concat(baseId)));
    _this2.missingRef = resolve_1.resolveUrl(baseId, ref);
    _this2.missingSchema = resolve_1.normalizeId(resolve_1.getFullPath(_this2.missingRef));
    return _this2;
  }

  return MissingRefError;
}(_wrapNativeSuper(Error));

exports.MissingRefError = MissingRefError;
module.exports = {
  ValidationError: ValidationError,
  MissingRefError: MissingRefError
};